import React from 'react';
import ScDateControl from '@/components/sc-controls/form-controls/v2/ScDateControl';
import { FieldProps } from '../form-helpers';

export type FormFieldDateProps = Omit<FieldProps, 'value' | 'onChange'> & {
    value: Date | null;
    onChange: (value: Date | null) => void;
};

function FormFieldDate({ label, required, value, onChange, onBlur, error, disabled, inTable }: FormFieldDateProps) {
    return (
        <ScDateControl
            label={label}
            required={required}
            value={value}
            onChange={(val: Date | null) => onChange(val)}
            onBlur={onBlur}
            error={error}
            disabled={disabled}
            maw={inTable ? '100%' : undefined}
            // Mantine's DateInput decides whether to show its clear ('x') button from
            // `clearable && value && !readOnly` alone - it never checks `disabled`, unlike Select.
            // So a disabled DateInput still renders a fully clickable clear button unless
            // `clearable` itself is turned off here.
            clearable={!disabled}
        />
    );
}

export default React.memo(FormFieldDate);
